export default "__VITE_ASSET__8LLix40m__"